module.exports = __webpack_public_path__ + "static/media/Missatges.4cc0cbe8.svg";